import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	OnInit,
	Output,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { CategoryList } from '../../models/category.model'
import { SharedService } from 'src/app/shared/services/shared.service'
import { AddEditBrandComponent } from '../../components/add-edit-brand/add-edit-brand.component'
import { MatDialog } from '@angular/material/dialog'
import { StoreService } from '../../services/store.service'
import { FlatTreeControl } from '@angular/cdk/tree'
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { TranslateService } from '@ngx-translate/core'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-categories-list',
	templateUrl: './categories-list.component.html',
	styleUrls: ['./categories-list.component.scss'],
})
export class CategoriesListComponent implements OnInit {
	subscription = new Subscription()
	searchText: any
	@Output() activationState = new EventEmitter()
	displayedColumns: string[] = ['NameEN', 'NameAr', 'count', 'activation', 'a']
	categories: CategoryList[] = []
	totalCount = 0
	attachmentUrl = environment.attachmentPath
	expandedRows: { [key: string]: boolean } = {}
	constructor(
		private SharedService: SharedService,
		private dialog: MatDialog,
		private categoryService: StoreService,
		public translate: TranslateService,
		private cd: ChangeDetectorRef
	) {
		this.SharedService.headerTitle.next(`STORE.CATEGORY_LIST.PAGE_TITLE`)
	}
	private _transformer = (cat: CategoryList, level: number) => {
		return {
			expandable: !!cat.subCategories && cat.subCategories.length > 0,
			name: {
				ar: cat.name?.ar,
				en: cat.name?.en,
			},
			productCount: cat.productCount,
			isActive: cat.isActive,
			level,
			id: cat.id,
			imageUrl: cat.imageUrl,
			canDelete: cat.canDelete,
			canAdd: cat.canAdd,
			subCategories: cat.subCategories,
			parentId: cat.parentId,
			hasSubCategories: cat.hasSubCategories,
		}
	}

	treeControl = new FlatTreeControl<any>(
		(cat) => cat.level,
		(cat) => cat.expandable
	)

	treeFlattener = new MatTreeFlattener(
		this._transformer,
		(cat) => cat.level,
		(cat) => cat.expandable,
		(cat) => cat.subCategories
	)

	dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener)
	ngOnInit(): void {
		this.SharedService.handleBreadCrumb('categories', true, {
			name: '',
			id: '',
			url: '/layout/store/categories',
		})
		this.getCategories()
	}

	getCategories(search = false) {
		this.subscription.add(
			this.categoryService.getCategories().subscribe((res: any) => {
				this.categories = res.result
				if (search && this.searchText) {
					this.translate.currentLang == 'ar'
						? (this.categories = this.categories.filter((item: any) =>
								item.name?.ar
									.toLowerCase()
									.includes(this.searchText.toLowerCase())
						  ))
						: (this.categories = this.categories.filter((item: any) =>
								item.name?.en
									.toLowerCase()
									.includes(this.searchText.toLowerCase())
						  ))
				}

				this.dataSource.data = this.categories
			})
		)
	}
	addCategory(type: string) {
		this.dialog
			.open(AddEditBrandComponent, {
				width: '585px',
				data: {
					formEditedData: {
						parentId: null,
					},
					typeTitle: 'cat',

					title: 'ACTIONS.ADD_CATEGORY',
					type: type,
					label: 'STORE.CATEGORY_LIST.ENGLISH_NAME',
					label2: 'STORE.CATEGORY_LIST.ARABIC_NAME',
					confirmBtn: 'ACTIONS.ADD',
					cancelBtn: 'ACTIONS.CANCEL',
					hasImg: true,
				},
				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						const newCategory = {
							name: {
								en: res.f1,
								ar: res.f2,
							},

							imageUrl: res.f3,
							parentId: null,
							isActive: true,
						}

						this.subscription.add(
							this.categoryService.addCategory(newCategory).subscribe((res) => {
								this.getCategories()
							})
						)
					}
				},
			})
	}

	addEditSubCategory(parentCategory: CategoryList, type?: string) {
		const parentId = parentCategory.parentId

		this.dialog
			.open(AddEditBrandComponent, {
				width: '585px',
				data: {
					type: type,
					formEditedData:
						type == 'add'
							? {
									parentId: parentCategory?.parentId,
							  }
							: {
									enName: parentCategory?.name?.en,
									arName: parentCategory?.name?.ar,
									imageUrl: parentCategory?.imageUrl,
									parentId: parentCategory?.parentId,
							  },
					hasImg:
						parentCategory.parentId == null && type != 'add' ? true : false,
					typeTitle: 'cat',

					title:
						type == 'add' && parentCategory.parentId == null
							? 'ACTIONS.ADD_SUBCATEGORY'
							: type == 'edit' && parentCategory.parentId != null
							? 'ACTIONS.EDIT_SUBCATEGORY'
							: type == 'add' && parentCategory.parentId != null
							? 'ACTIONS.ADD_SUBCATEGORY'
							: 'ACTIONS.EDIT_CATEGORY',
					label:
						type == 'add' && parentCategory.parentId == null
							? 'STORE.CATEGORY_LIST.SUB_ENGLISH_NAME'
							: type == 'edit' && parentCategory.parentId != null
							? 'STORE.CATEGORY_LIST.SUB_ENGLISH_NAME'
							: type == 'add' && parentCategory.parentId != null
							? 'STORE.CATEGORY_LIST.SUB_ENGLISH_NAME'
							: 'STORE.CATEGORY_LIST.ENGLISH_NAME',
					label2:
						type == 'add' && parentCategory.parentId == null
							? 'STORE.CATEGORY_LIST.SUB_ARABIC_NAME'
							: type == 'edit' && parentCategory.parentId != null
							? 'STORE.CATEGORY_LIST.SUB_ARABIC_NAME'
							: type == 'add' && parentCategory.parentId != null
							? 'STORE.CATEGORY_LIST.SUB_ARABIC_NAME'
							: 'STORE.CATEGORY_LIST.ARABIC_NAME',
					confirmBtn: type == 'add' ? 'ACTIONS.ADD' : 'ACTIONS.EDIT',
					cancelBtn: 'ACTIONS.CANCEL',
				},
				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						if (type == 'add') {
							let newCategory = {
								parentId: parentCategory.id,
								name: {
									en: res.f1,
									ar: res.f2,
								},
								isActive: true,
							}
							this.subscription.add(
								this.categoryService
									.addCategory(newCategory)
									.subscribe((res) => {
										this.getCategories()
										setTimeout(() => {
											const nodeToExpand = this.treeControl.dataNodes.find(
												(node) => node.id == parentId
											)
											if (nodeToExpand.parentId == null) {
												this.treeControl.expand(nodeToExpand)
											} else if (nodeToExpand.parentId != null) {
												const nodeToExpandtwo = this.treeControl.dataNodes.find(
													(node) => node.id == nodeToExpand.parentId
												)
												this.treeControl.expand(nodeToExpandtwo)
												this.treeControl.expand(nodeToExpand)
											}
										}, 300)
									})
							)
						} else {
							let data = {
								id: parentCategory.id,
								name: {
									en: res.f1,
									ar: res.f2,
								},
								imageUrl: res.f3,
								parentId: parentCategory.parentId,
								isActive: parentCategory.isActive,
								canDelete: parentCategory.canDelete,
								productCount: parentCategory.productCount,
								subCategories: parentCategory.subCategories,
							}
							this.subscription.add(
								this.categoryService
									.updateCategoryStatus(data)
									.subscribe((res) => {
										this.getCategories()
										setTimeout(() => {
											const nodeToExpand = this.treeControl.dataNodes.find(
												(node) => node.id == parentId
											)
											if (nodeToExpand.parentId == null) {
												this.treeControl.expand(nodeToExpand)
											} else if (nodeToExpand.parentId != null) {
												const nodeToExpandtwo = this.treeControl.dataNodes.find(
													(node) => node.id == nodeToExpand.parentId
												)
												this.treeControl.expand(nodeToExpandtwo)
												this.treeControl.expand(nodeToExpand)
											}
										}, 300)
									})
							)
						}
					}
				},
			})
	}
	updateCategoryStatus(cat: any) {
		const parentId = cat.parentId

		let requestBody = {
			id: cat.id,
			isActive: !cat.isActive,
		}
		this.subscription.add(
			this.categoryService
				.ChangeCategoryActivationStatus(requestBody.id, requestBody.isActive)
				.subscribe((res) => {
					this.getCategories()

					// After reloading the categories, expand the specific node
					setTimeout(() => {
						// Find the updated node using the parent ID
						const nodeToExpand = this.treeControl.dataNodes.find(
							(node) => node.id == parentId
						)
						if (nodeToExpand.parentId == null) {
							this.treeControl.expand(nodeToExpand)
						} else if (nodeToExpand.parentId != null) {
							const nodeToExpandtwo = this.treeControl.dataNodes.find(
								(node) => node.id == nodeToExpand.parentId
							)
							this.treeControl.expand(nodeToExpandtwo)
							this.treeControl.expand(nodeToExpand)
						}
					}, 300) // Adjust the delay as needed
				})
		)
	}

	deleteCategory(categoryData: CategoryList) {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '416',
				height: '360',
				data: {
					message: this.translate.instant('CONFIRMATION_MESSAGE.DELETE_CAT', {
						name:
							this.translate.currentLang == 'ar'
								? categoryData?.name?.ar
								: categoryData?.name?.en,
					}),
					typeTitle: 'cat',
					title: `${this.translate.instant('ACTIONS.DELETE')}${' '}${
						this.translate.currentLang == 'ar'
							? categoryData?.name?.ar
							: categoryData?.name?.en
					}`,
					notflex: true,
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: 'ACTIONS.DELETE',
					confirmBtnStyle: `text-off-white bg-[#B3261E] h-[52px]`,
					msgStyle: 'text-[14px] text-[#6E7191]',
					titleStyle:
						'ltr:font-DIN-bold font-bold rtl:font-semibold text-[24px] text-[#4E4B66]',
					cancelBtnStyle: ` border-[1px] border-secondry-color-Gray h-[52px] text-dark-grey border-solid`,
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.categoryService
							.deleteCategory(categoryData.id)
							.subscribe((res) => {
								this.getCategories()
							})
					}
				},
			})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
